

<app-page-header [title]="'Edit Brand'" [backLink]="['/Brand']"></app-page-header>


<!-- <nz-card style="margin-bottom: 3rem;">
  <div nz-col [nzSpan]="9" class="form-section" >
    <nz-form-label nz-col [nzSpan]="6" nzFor="industryType" nzLabelAlign="left">Select Brand  <span style="color: red;"> * </span></nz-form-label>
    <nz-form-item>
      
      <nz-form-control nz-col nzSpan="16" >
        <nz-select id="selectbrand"  nzPlaceHolder="Select Brand"  [(ngModel)]="selectbrand" (ngModelChange)="getBranddetails(selectbrand)">
          <nz-option *ngFor="let name of names"  [nzValue]="name.brandName" nzLabel="{{name.brandName}}"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
  </nz-card> -->


  <nz-card style="width: 100%;">
    <form class="my" nz-row [nzGutter]="16"  nzAlign="middle" nzJustify="space-around" style="margin-bottom: 2rem; margin-top: 2rem; ">
      <!-- <div nz-col [nzSpan]="6">
          
          <nz-form-control >
              <label for="Admin"> Select Admin*</label>
              <nz-select id="Reseller" nzPlaceHolder="Select a user" [(ngModel)]="Admin" [ngModelOptions]="{standalone: true}" (ngModelChange)="getUserData(Admin,'admin')">
                      <nz-option *ngFor="let admin of Adminlist" [nzValue]="admin.label" [nzLabel]="admin.label" ></nz-option>
                      
              </nz-select>
          </nz-form-control>
      </div> -->
  
      <!-- <div nz-col [nzSpan]="6">
        
        <nz-form-control >
            <label for="Reseller"> Select Reseller*</label>
            <nz-select id="Reseller" nzPlaceHolder="Select a user" [(ngModel)]="Reseller" [ngModelOptions]="{standalone: true}" (ngModelChange)="getUserData(Reseller,'reseller')">
                    <nz-option *ngFor="let reseller of ResllerList" [nzValue]="reseller.label" [nzLabel]="reseller.label" ></nz-option>
                    
            </nz-select>
        </nz-form-control>
    </div>
    <div nz-col [nzSpan]="6">
        
        <nz-form-control >
            <label for="Seller"> Select Seller*</label>
            <nz-select id="Seller" nzPlaceHolder="Select a user" [(ngModel)]="Seller" [ngModelOptions]="{standalone: true}" (ngModelChange)="getUserData(Seller,'Seller')">
                
                    <nz-option *ngFor="let seller of SellerList;" [nzValue]="seller.label" [nzLabel]="seller.label"></nz-option>
                  
            </nz-select>
        </nz-form-control>
    </div> -->
    <!-- <div nz-col [nzSpan]="6">
        
        <nz-form-control >
            <label for="Client"> Select Client*</label>
            <nz-select id="Client"  nzPlaceHolder="Select a user" [(ngModel)]="client" [ngModelOptions]="{standalone: true}" (ngModelChange)="getUserData(client,'client')">
                
                    <nz-option *ngFor="let Client of Clientlist" [nzValue]="Client.label" [nzLabel]="Client.label"></nz-option>
                  
            </nz-select>
        </nz-form-control>
    </div>
   -->
  
  </form>

  <!-- <div nz-col [nzSpan]="9" class="newsection" *ngIf="isUserSelected">
    <nz-form-label nz-col [nzSpan]="6" nzFor="industryType" nzLabelAlign="left">Select Brand  <span style="color: red; " > * </span></nz-form-label>
    <nz-form-item>
      
      <nz-form-control nz-col nzSpan="16" >
        <nz-select id="selectbrand"  nzPlaceHolder="Select Brand" [(ngModel)]="selectbrand" (ngModelChange)="getBranddetails(selectbrand)">
          <nz-option *ngFor="let name of names"  [nzValue]="name.brandName" nzLabel="{{name.brandName}}"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div *ngIf="selectbrand "> -->
   
 <form nz-form [formGroup]="updatebrand"  class="brand-form"  >
    <!-- Brand Information Section -->
    <nz-divider nzText="Update Information" nzOrientation="left" style="margin-left: -65px; color: black; " ></nz-divider>
    
    <div nz-row [nzGutter]="24" style=" padding-top: 24px; border-top: 2px rgb(225, 225, 225); ">
      
     
      <div nz-col [nzSpan]="12" class="form-section" >
   
        <nz-form-item>
          <nz-form-label nz-col [nzSpan]="6" nzFor="brandName" nzLabelAlign="left">Brand Name  <span style="color: red;"> * </span> </nz-form-label>
          <nz-form-control nz-col nzSpan="16" nzHasFeedback nzErrorTip="Please enter brand name">
            <input id="brandName" nz-input formControlName="brandName"  placeholder="Enter Brand Name" />
          </nz-form-control>
        </nz-form-item>
     
      </div>
      
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label nz-col [nzSpan]="6" nzFor="officialWebsite" nzLabelAlign="left" >Official Website  <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control nz-col nzSpan="16" nzErrorTip="Please enter website URL">
            <input id="officialWebsite" nz-input formControlName="officialWebsite" placeholder="https://example.com" />
          </nz-form-control>
        </nz-form-item>
      </div>
      
     

      <!-- <div nz-col [nzSpan]="12" class="form-section" >
        <nz-form-item>
          <nz-form-label nz-col [nzSpan]="6" nzLabelAlign="left" nzRequired>Bot Logo</nz-form-label>
          <nz-form-control nzHasFeedback nz-col nzSpan="16" nzErrorTip="Bot Logo!">
            <input type="file" formControlName="botlogo" (change)="onFileSelected($event)" accept=".jpg, .jpeg, .png" />
          </nz-form-control>
        </nz-form-item>
      </div> -->

      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-label nz-col [nzSpan]="6" nzLabelAlign="left">Brand Logo  <span style="color: red;"> * </span></nz-form-label>
        <nz-form-item>
          <nz-form-control [nzSm]="10" [nzXs]="12" nzErrorTip="Bot Logo!">
            <div class="" style="display: flex; flex-direction: column; align-items: center; gap: 10px;">
              <!-- <img src="assets\images\size-brand.png" *ngIf="!backgroundUrl" alt="" style="width: 200px; height: 150px;"> -->
              <div *ngIf="backgroundUrl" class="preview-container">
                
                <img [src]="backgroundUrl" alt="Bot Logo Preview" class="image-preview" />
              </div>
              <button nz-button nzType="primary" (click)="showModal()" class="uploadbtn">
                <span>Upload</span>
              </button>
          </div>
            <nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle" [nzContent]="modalContent"
              [nzFooter]="modalFooter" (nzOnCancel)="handleCancel()">

              
              <ng-template #modalTitle>Select An Image</ng-template>

              <ng-template #modalContent>
                <nz-tabset>
                  <nz-tab nzTitle="Upload Image">
                    <p>The image you upload must be 224 pixels wide x 224 pixels tall, have a max file size of 90KB, and be a JPEG, JPG or PNG. IF the image you select doesn’t meet these requirements, you’ll have the opportunity to edit it.</p>
                    <!-- <nz-upload nzType="drag" [nzMultiple]="true"
                      nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76" (nzChange)="onFileSelectedBackground($event)" formControlName="bannerimage" style="width: 100% ;">
                      <p class="ant-upload-drag-icon" >
                        <span nz-icon nzType="inbox"></span>
                      </p>
                      <p class="ant-upload-text">Click or drag file to this area to upload</p>
                      
                    </nz-upload> -->

                    <input type="file" (change)="fileChangeEvent($event)" />
                    <image-cropper [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [aspectRatio]=" 1/ 1"
                    [resizeToWidth]="224"
                    [resizeToHeight]="224"
                    (imageCropped)="imageCropped($event)"></image-cropper>
                    

                  </nz-tab>
                  <nz-tab nzTitle="Upload By Link">
                    <p>The image you upload must be 224 pixels wide x 224 pixels tall, have a max file size of 90KB, and be a JPEG, JPG or PNG. IF the image you select doesn’t meet these requirements, you’ll have the opportunity to edit it.</p>
                    <p>Upload Image by link</p>
                    <input type="text" nz-input placeholder="Enter Image URL" accept=".jpg, .jpeg, .png" />
                    <button nz-button nzType="primary">Upload</button>

                  </nz-tab>

                </nz-tabset>
              </ng-template>

              <ng-template #modalFooter>
                <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
                <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">Submit</button>
              </ng-template>
            </nz-modal>

            <!-- <div *ngIf="backgroundUrl" class="preview-container">
              <p>Banner Preview:</p>
              <img [src]="backgroundUrl" alt="Banner Preview" class="image-preview" />
            </div> -->
          </nz-form-control>
        </nz-form-item>
      </div>

        
        <!-- <div  *ngIf="imageUrl" class="preview-container">
        
            <p style=" margin-left: -300px;  margin-top: 10px; display: block;" >Image Preview:</p>
          <img [src]="imageUrl" alt="Bot Logo Preview" class="image-preview" style="max-width: 80px; margin-left: -300px;  margin-top: 10px; display: block;  " />
        </div> -->
      
      
      
      
      
      
      <div nz-col [nzSpan]="12" class="form-section" >
        <nz-form-item>
          <nz-form-label nz-col [nzSpan]="6" nzFor="industryType" nzLabelAlign="left">Industry Type  <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control nz-col nzSpan="16">
            <nz-select id="industryType" formControlName="industryType" nzPlaceHolder="Select Industry">
              <nz-option nzValue="technology" nzLabel="Technology"></nz-option>
              <nz-option nzValue="retail" nzLabel="Retail"></nz-option>
              <nz-option nzValue="manufacturing" nzLabel="Manufacturing"></nz-option>
              <!-- Add more options as needed -->
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div *ngIf="imageUrl" class="preview-container">
        <p style="margin-left: 40px;">Image Preview:</p>
        <img [src]="imageUrl" alt="Bot Logo Preview" class="image-preview"
          style="margin-left: 45px; max-width: 90px; margin-top: 5px; display: block; border-radius: 10px; box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);" />
      </div>
   
    </div>

   

    <!-- Contact Person Section -->
    <nz-divider nzText="Contact Person Details" nzOrientation="left" style="margin-left: -65px; color: black; "></nz-divider>
    
    <div nz-row [nzGutter]="24" style="border-top: 2px rgb(225, 225, 225); padding-top: 24px; ">

      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label nzFor="firstName" nzLabelAlign="left"  nz-col [nzSpan]="6">First Name  <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control nzHasFeedback nz-col nzSpan="16" >
            <input id="firstName" nz-input formControlName="firstName" placeholder="Enter First Name" />
          </nz-form-control>
        </nz-form-item>
      </div>
      
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label  nzFor="lastName" nzLabelAlign="left"  nz-col [nzSpan]="6" >Last Name  <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control nzHasFeedback  nzSpan="16">
            <input id="lastName" nz-input formControlName="lastName" placeholder="Enter Last Name" />
          </nz-form-control>
        </nz-form-item>
      </div>
  

    
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label nzFor="designation" nzLabelAlign="left" nz-col [nzSpan]="6"  >Designation  <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control  nzHasFeedback  nzSpan="16" >
            <input id="designation" nz-input formControlName="designation" placeholder="Enter Designation" />
          </nz-form-control>
        </nz-form-item>
      </div>
      
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label nzFor="mobileNumber" nzLabelAlign="left" nz-col [nzSpan]="6" >Mobile Number  <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control nzSpan="16" >
            <nz-input-group [nzAddOnBefore]="prefixTemplate">
              <input id="mobileNumber" nz-input formControlName="mobileNumber" placeholder="Enter Mobile Number" />
            </nz-input-group>
            <ng-template #prefixTemplate>
              <nz-select formControlName="phonePrefix" class="phone-select">
                <nz-option nzLabel="+91" nzValue="+91">+91</nz-option>
                <!-- Add more country codes as needed -->
              </nz-select>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
      
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label nzFor="email" nzLabelAlign="left" nz-col [nzSpan]="6" >Email ID  <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control nzHasFeedback nzSpan="16" >
            <input id="email" nz-input formControlName="email" placeholder="Enter Email ID" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  

    <!-- Address Section -->
    <nz-divider nzText="Company Address" nzOrientation="left" style="margin-left: -65px;  color: black;  "></nz-divider>
    
    <div nz-row [nzGutter]="24" style=" padding-top: 24px; border-top: 2px rgb(225, 225, 225); " >
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label  nzFor="addressLine1" nzLabelAlign="left" nz-col [nzSpan]="6" >Address Line 1 <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control nzSpan="16">
            <input id="addressLine1" nz-input formControlName="addressLine1" placeholder="Enter Address Line 1" />
          </nz-form-control>
        </nz-form-item>
      </div>
      
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label nzFor="addressLine2" nzLabelAlign="left" nz-col [nzSpan]="6"  >Address Line 2</nz-form-label>
          <nz-form-control   nzSpan="16" >
            <input id="addressLine2" nz-input formControlName="addressLine2" placeholder="Enter Address Line 2" />
          </nz-form-control>
        </nz-form-item>
      </div>
   

   
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label nzFor="city" nzLabelAlign="left" nz-col [nzSpan]="6"  >City  <span style="color: red;"> * </span> </nz-form-label>
          <nz-form-control nzSpan="16">
            <input id="city" nz-input formControlName="city" placeholder="Enter City" />
          </nz-form-control>
        </nz-form-item>
      </div>
      
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label nzFor="state" nzLabelAlign="left" nz-col [nzSpan]="6"  >State/Province  <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control nzSpan="16">
            <input id="state" nz-input formControlName="state" placeholder="Enter State" />
          </nz-form-control>
        </nz-form-item>
      </div>
      
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label nzFor="postalCode" nzLabelAlign="left" nz-col [nzSpan]="6" >ZIP/Postal Code <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control nz-col nzSpan="16" >
            <input id="postalCode" nz-input formControlName="postalCode"  placeholder="Enter ZIP Code" />
          </nz-form-control>
        </nz-form-item>
      </div>
      
      <div nz-col [nzSpan]="12" class="form-section">
        <nz-form-item>
          <nz-form-label  nzFor="country" nzLabelAlign="left" nz-col [nzSpan]="6" >Country  <span style="color: red;"> * </span></nz-form-label>
          <nz-form-control  nzSpan="16" >
            <nz-select id="country" formControlName="country" nzShowSearch nzPlaceHolder="Select Country">
             
              <nz-option nzValue="India" nzLabel="India"></nz-option>
              <nz-option nzValue="UK" nzLabel="United Kingdom"></nz-option>
              <!-- Add more countries as needed -->
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    

    <!-- Action Buttons -->
    <div class="action-buttons-container">
      <div class="centered-buttons">
        <button nz-button nzType="default" (click)="onBack()" class="action-button">
          <i nz-icon nzType="left"></i>Back
        </button>
        <button nz-button nzType="primary" type="submit" class="action-button" (click)="onSubmit()">
          <i nz-icon nzType="save"></i>Submit
        </button>
      </div>
    </div>
  </form>
  
  </nz-card>